// Shared by score photos and task screenshots: both are checked against the
// same 3 MB server ceiling (server photoStorage.js / taskAttachmentStorage.js).
export const MAX_UPLOAD_BYTES = 3 * 1024 * 1024;
const TARGET_WIDTH = 1200;
const JPEG_QUALITY = 0.85;

/**
 * Shrink an image in the browser before it goes anywhere.
 *
 * This is what makes uploading work on club wifi and a weak signal. A modern
 * phone camera produces several megabytes; the picture only needs to be legible.
 */
export async function compressImage(file, fileName = 'image.jpg') {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, TARGET_WIDTH / bitmap.width);
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY));
  bitmap.close?.();
  // If shrinking somehow made it bigger, keep the original.
  return blob && blob.size < file.size
    ? new File([blob], fileName, { type: 'image/jpeg' })
    : file;
}
